import axios   from 'axios';
import Cookies from 'js-cookie'
import User    from './user'

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Security {

  static endpoints = {
    register             : `${baseUrl}/user/register`,
    registerConfirmation : `${baseUrl}/user/confirmation`,

    loginEmail           : `${baseUrl}/auth/login`,
    loginGoogle          : `${baseUrl}/auth/login/google`,
    loginFb              : `${baseUrl}/auth/login/facebook`,
    logout               : `${baseUrl}/auth/logout`,

    resetPasswordRequest : `${baseUrl}/user/reset-password-request`,
    resetPassword        : `${baseUrl}/user/reset-password`,
  };

  static get currentUserValue() {
    return JSON.parse(localStorage.getItem("currentUser"));
  }

  static register(credentials) {
    return axios.post(this.endpoints.register, credentials).then((response)=> response.data.message);
  };

  static registerConfirmation(token) {
    return axios.get(`${this.endpoints.registerConfirmation}/${token}`).then((response)=> response.data.message);
  };

  static loginEmail(credentails) {
    return this.login(this.endpoints.loginEmail, credentails);
  };

  static loginGoogle(credentails) {
    return this.login(this.endpoints.loginGoogle, credentails);
  };

  static loginFacebook(credentails) {
    return this.login(this.endpoints.loginFb, credentails);
  };

  static resetPasswordRequest(credentials) {
    return axios.post(this.endpoints.resetPasswordRequest,credentials).then((response)=> response.data.message);
  };

  static resetPassword(token, credentials) {
    return axios.post(`${this.endpoints.resetPassword}/${token}`, credentials).then((response)=> response.data.message);
  };

  static logout()  {
    return axios.get(this.endpoints.logout)
      .catch(()=> false)
      .finally(()=> {
        localStorage.removeItem("currentUser");
        Cookies.remove('uuid');
        window.location  = "/login";
      });
  };

  static async login(endpoint, body) {
    let response = await axios.post(endpoint, body).then((response)=> response.data);
    Cookies.set('uuid', response.uuid, {sameSite: "lax", domain: process.env.REACT_APP_COOKIE_DOMAIN, expires: 90});

    const userDetails = await User.account(response.uuid);

    localStorage.setItem("currentUser", JSON.stringify(userDetails));
    return response.message;
  };
}
